import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { PaymentCreditRouter } from './payment-credit.router';
import { reducers } from './state/payment-credit.selectors';

@NgModule({
  imports: [
    PaymentCreditRouter,
    StoreModule.forFeature('paymentCredit', reducers),
  ],
  declarations: []
})
export class PaymentCreditScreenModule { }